import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getGameDropdown = async () => {
  return serviceHelper(http.get('/game/dropdown'), false);
};

export const getGameDetails = async (id: string) => {
  return serviceHelper(http.get(`/game/${id}`), false);
};

export const getLessonGameList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/game/lesson-game-list?${queryString}`),
    false
  );
};

export const getLessonAvailableGames = async (
  lessonId: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/lesson/${lessonId}/available-games?${queryString}`),
    false
  );
};

export const getSkillsDropdown = async () => {
  return serviceHelper(http.get('/game/skills-dropdown'), false);
};

export const getQuarterViewGameDetails = async (id: string) => {
  return serviceHelper(http.get(`/game/${id}/details`), false);
};
